/**
 * Data source related constants.
 */
const DataSourceConstants = {
    DATA_SOURCE_TERM_ANALYTICS: "Analytics",
    DATA_SOURCE_TERM_APPLICATION: "Application",
    DATA_SOURCE_TERM_CLOUD_COMPUTING: "Cloud Computing",
    DATA_SOURCE_TERM_DATA_INTEGRATION: "Data Integration",
    DATA_SOURCE_TERM_DEPLOYMENT: "Deployment",
    DATA_SOURCE_TERM_DEVELOPER_RELATED: "Developer-Related",
    DATA_SOURCE_TERM_PRODUCT_OR_SERVICE: "Product Or Service",
    DATA_SOURCE_TERM_SECURE_ACCESS: "Secure Access",
    DATA_SOURCE_TERM_REPOSITORIES: "Repositories",
    DATA_SOURCE_TERM_SEARCH: "data-source.search-text",
    DATA_SOURCE_NO_RECORDS: "data-source.no-results-text",
    DATA_SOURCE_CLEAR_FILTERS: "data-source.clear-filters",
    DATA_SOURCE_LOAD_MORE: "data-source.load-more-text",
    DATA_SOURCE_NUMBER_PER_PAGE: 12,
    DATA_SOURCE_RESULTS_COUNT_TEXT: "data-source.results-count-text",
};

/**
 * Mapping of Data source taxonomy terms to their corresponding fields in the data model.
 */
const TaxonomyMapping = {
    [DataSourceConstants.DATA_SOURCE_TERM_ANALYTICS]: "analytics",
    [DataSourceConstants.DATA_SOURCE_TERM_APPLICATION]: "application",
    [DataSourceConstants.DATA_SOURCE_TERM_CLOUD_COMPUTING]: "cloudComputing",
    [DataSourceConstants.DATA_SOURCE_TERM_DATA_INTEGRATION]: "dataIntegration",
    [DataSourceConstants.DATA_SOURCE_TERM_DEPLOYMENT]: "deployment",
    [DataSourceConstants.DATA_SOURCE_TERM_DEVELOPER_RELATED]: "developerRelated",
    [DataSourceConstants.DATA_SOURCE_TERM_PRODUCT_OR_SERVICE]: "productOrService",
    [DataSourceConstants.DATA_SOURCE_TERM_REPOSITORIES]: "repositories",
    [DataSourceConstants.DATA_SOURCE_TERM_SECURE_ACCESS]: "secureAccess",
};

/**
 * Exporting the constants and mappings.
 */
export { DataSourceConstants, TaxonomyMapping };
